module.exports = __webpack_public_path__ + "img/achievement.ae667579.png";